import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { ItemConditional } from '../../../primitives/Grid/Item/components/ItemConditional/index.js';
import { ItemMQ } from '../../../primitives/Grid/Item/components/ItemMQ.js';
export const Item = /*#__PURE__*/_styled(forwardRef(({
  mq,
  children,
  ...restProps
}, ref) => {
  if (mq) {
    return _jsx(ItemMQ, {
      ...restProps,
      ref: ref,
      children: children
    });
  }
  return (
    // @ts-expect-error TS(2322) FIXME: Type '{ children: ReactNode; ref: ForwardedRef<HTM... Remove this comment to see the full error message
    _jsx(ItemConditional, {
      ...restProps,
      ref: ref,
      children: children
    })
  );
}), process.env.NODE_ENV === "production" ? {
  target: "ee1okcg0"
} : {
  target: "ee1okcg0",
  label: "Item"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWUkiLCJmaWxlIjoiSXRlbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgSXRlbUNvbmRpdGlvbmFsIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9HcmlkL0l0ZW0vY29tcG9uZW50cy9JdGVtQ29uZGl0aW9uYWwvaW5kZXguanMnO1xuaW1wb3J0IHsgSXRlbU1RIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9HcmlkL0l0ZW0vY29tcG9uZW50cy9JdGVtTVEuanMnO1xuZXhwb3J0IGNvbnN0IEl0ZW0gPSBzdHlsZWQoZm9yd2FyZFJlZigoeyBtcSwgY2hpbGRyZW4sIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IHtcbiAgICBpZiAobXEpIHtcbiAgICAgICAgcmV0dXJuIChfanN4KEl0ZW1NUSwgeyAuLi5yZXN0UHJvcHMsIHJlZjogcmVmLCBjaGlsZHJlbjogY2hpbGRyZW4gfSkpO1xuICAgIH1cbiAgICByZXR1cm4gKFxuICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgVFMoMjMyMikgRklYTUU6IFR5cGUgJ3sgY2hpbGRyZW46IFJlYWN0Tm9kZTsgcmVmOiBGb3J3YXJkZWRSZWY8SFRNLi4uIFJlbW92ZSB0aGlzIGNvbW1lbnQgdG8gc2VlIHRoZSBmdWxsIGVycm9yIG1lc3NhZ2VcbiAgICBfanN4KEl0ZW1Db25kaXRpb25hbCwgeyAuLi5yZXN0UHJvcHMsIHJlZjogcmVmLCBjaGlsZHJlbjogY2hpbGRyZW4gfSkpO1xufSkpIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9SXRlbS5qcy5tYXAiXX0= */");